import { useCallback, useMemo, useState } from "react"
import useConnectWallet from "@/store/wallet/useConnectWallet";
import { toast } from "react-toastify";

/**
 * useFlowClaim - 提取收益 Hook（交易类）
 * 
 * 用于调用 FlowDeposit 合约的 claim 方法提取指定质押记录的收益。
 * 通过 tx.wait() 等待交易确认，使用 toast 显示交易结果提示。
 * 
 * @param successFn - 可选的成功回调函数，在交易成功后调用
 * @param errorFn - 可选的失败回调函数，在交易失败后调用
 * @returns {Object} 返回提取收益的方法和加载状态
 *   - getFlowClaim: 执行提取收益的函数
 *   - flowClaimLod: 加载状态，表示交易是否正在进行中
 */
const useFlowClaim = (type = 0) => {
    // 加载状态
    const [flowClaimLod, setLoading] = useState(false)
    // 从 useConnectWallet 获取 FlexibleStaking 合约实例
    const { contractEvm: { FlexibleStaking, RegularStaking } } = useConnectWallet()
    const con = useMemo(() => [
        FlexibleStaking, RegularStaking
    ], [FlexibleStaking, RegularStaking])
    /**
     * 提取收益函数
     * @param id - 质押记录的 ID
     */
    const getFlowClaim = useCallback(async (id: bigint,
        toastText: { success: string; error: string },
        successFn?: Function, errorFn?: Function
    ) => {
        if (FlexibleStaking) {
            setLoading(true)
            try {
                // 调用合约的 claim 方法
                const tx = await con[type]?.claim(id)
                // 等待交易确认
                await tx.wait()
                // 显示成功提示
                toast.success(toastText.success)
                // 成功后调用成功回调函数
                successFn && successFn();

            } catch (e) {
                console.log('useFlowClaim', e);
                // 显示失败提示
                toast.error(toastText.error)
                // 失败后调用失败回调函数
                errorFn && errorFn();
            } finally {
                setLoading(false)
            }
        }
    }, [FlexibleStaking, con, type])

    return { getFlowClaim, flowClaimLod }
}

export default useFlowClaim